// extracted by mini-css-extract-plugin
module.exports = {"CalloutSection":"CalloutSection_CalloutSection__kHYTm","Overlay":"CalloutSection_Overlay__2WBOX"};